var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReplay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 15.514 15.514 20 10 20C4.48596 20 0 15.514 0 10H1C1 14.9626 5.03735 19 10 19C14.9626 19 19 14.9626 19 10C19 5.03735 14.9626 1 10 1C7.28075 1 4.87634 2.23776 3.16543 4.5H6.5V5.5H1.5V0.5H2.5V3.72457C4.39378 1.31522 7.0257 0 10 0C15.514 0 20 4.48596 20 10ZM14.4313 10L7.5 14.4108V5.58917L14.4313 10ZM8.5 12.5892L12.5687 10L8.5 7.41083V12.5892Z",
    fill: "#EFF1F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplay);
export default __webpack_public_path__ + "static/media/replay.e70134c5606b9c486a1ba1d2a3f7e8bc.svg";
export { ForwardRef as ReactComponent };